import { OpenInNewIcon } from '@systemeio/ui/icons'
import { LinkProps as LinkType, default as NextLink } from 'next/link'
import React, { AnchorHTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

export type LinkProps = React.PropsWithChildren<LinkType> &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    showOpenInNewIcon?: boolean
  }

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ prefetch = false, className, children, showOpenInNewIcon, ...rest }, ref) => {
    return (
      <NextLink
        {...rest}
        ref={ref}
        prefetch={prefetch}
        className={twMerge(
          'text-brand-primary [&>svg>path]:fill-brand-primary main-transition-colors [&>svg>path]:main-transition-colors group-focus-visible:[&>svg>path]:fill-brand-primary flex items-center',
          '[&:hover]:text-text-secondary [&:hover>svg>path]:fill-text-secondary',
          showOpenInNewIcon && 'flex gap-1',
          className,
        )}
      >
        {children}

        {showOpenInNewIcon && <OpenInNewIcon />}
      </NextLink>
    )
  },
)

Link.displayName = 'Link'
